module.exports = __webpack_public_path__ + "img/logo.f62e0537.png";